import Service from "../../AuthService";
const AdvancePayment = {
    getAdvancePayment(page) {
        return Service.get("/advance_payment?page="+page);
    },
    showAdvancePayment(id) {
        return Service.get("/advance_payment/" + id);
    },
    showAdvancePaymentDetails(id) {
        return Service.get("/advance_payment_details/" + id);
    },
    updateAdvancePayment(id, data) {
        return Service.put("/advance_payment/" + id, data);
    },
    createAdvancePayment(data) {
        return Service.post("/advance_payment", data);
    },
    deleteAdvancePayment(id) {
        console.log(id);
        return Service.delete("/advance_payment/" + id);
    },
    searchAdvancePayment(data){
        return Service.post('/advance_payment_search',data);
    }

};
export default AdvancePayment;
